export enum SimCardTypeEnum {
  M2M = 'm2m',
  DEFAULT = 'default'
}
